
import Card from '../base/Card';

export default function TargetAudience() {
  const audiences = [
    {
      icon: 'ri-calendar-check-line',
      title: 'I\'m planning my retirement',
      description: 'Want to ensure you\'re on the right track and not miss any important rights.'
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'My benefit was denied or stopped',
      description: 'Need specialized defense to reverse unfair decisions by the INSS.'
    },
    {
      icon: 'ri-question-line',
      title: 'I doubt if I\'m entitled to any benefit',
      description: 'Want to clarify your possibilities without wasting time or opportunities.'
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
            Who is Laginestra for?
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            We serve people who need legal security in social security matters
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {audiences.map((audience, index) => (
            <Card key={index} hover className="text-center">
              <div className="w-16 h-16 bg-[#b86846] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${audience.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">
                {audience.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {audience.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
